import React, { useEffect, useState } from "react";
import { companyType } from "../../../types/comapnyTypes";
import ViewTable from "../../../components/tables/viewTable";
import dayjs from "dayjs";
import { MonthlyPaymentType } from "../../../types/paymentTypes";
type PropsType = {
  tableData: MonthlyPaymentType[];
};
const MonthlyPaymentTable = (props: PropsType) => {
  const { tableData } = props;
  const [modifiedTableData, setmodifiedTableData] = useState<
    MonthlyPaymentType[]
  >([]);

  const columns = [
    { header: "Month", accessor: "month" },
    { header: "Year", accessor: "year" },
    { header: "Transaction Count", accessor: "transactionCount" },
    {
      header: "Total Amount",
      accessor: "totalAmount",
      cell: (row: any) => `${Number(row?.totalAmount).formatRupee()}`,
    },
  ];

  useEffect(() => {
    if (tableData?.length < 1) return;
    setmodifiedTableData(tableData);
  }, [tableData]);
  return (
    <div>
      <ViewTable pagination={true} columns={columns} data={modifiedTableData} />
    </div>
  );
};

export default MonthlyPaymentTable;
